import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';

import Button from 'react-bootstrap/lib/Button';
import Row from 'react-bootstrap/lib/Row';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Image from '../WhyHostFormBlock1/Image';
import CommonFormComponent from '../../../CommonField/CommonFormComponent';
import MultiLanguageInput from '../../MultiLanguageInput/MultiLanguageInput';

import messages from '../../../../locale/messages';
import submit from './submit';
import validate from './validate';

import s from './WhyHostFormBlock3.css';
import cs from '../../../../components/commonStyle.css';

class WhyHostFormBlock3 extends Component {
  constructor(props) {
    super(props);
    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleFieldChange(fieldName, value) {
    const { dispatch } = this.props;
    dispatch(change('WhyHostForm', fieldName, value));
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, whyBlock1loader, whyBlock2loader, whyBlockImage1, whyBlockImage2, formValues } = this.props;
    const { formatMessage } = this.props.intl;

    // Hidden fields to register multilingual fields with Redux Form
    const multilingualFields = ['whyBlockTitle1', 'whyBlockTitle2', 'whyBlockContent1', 'whyBlockContent2'];
    const langSuffixes = ['_en', '_fr', '_it', '_pt'];
    const hiddenFields = [];
    multilingualFields.forEach(base => {
      langSuffixes.forEach(suffix => {
        hiddenFields.push(
          <Field key={`${base}${suffix}`} name={`${base}${suffix}`} component="input" type="hidden" />
        );
      });
    });

    return (
      <div className={cx(cs.adminContentPadding)}>
        <div className={s.sectionCenter}>
          <div className={cs.commonAdminBorderSection}>
            <h1 className={s.headerTitle}><FormattedMessage {...messages.WhyBecomeOwnerBlock3} /></h1>
            <form onSubmit={handleSubmit((values) => {
              const payload = { ...values, ...formValues };
              console.log('🚀 [WhyHostFormBlock3] Sending:', payload);
              return submit(payload, dispatch);
            })}>
              {hiddenFields}
              {error && <strong>{formatMessage(error)}</strong>}
              <FormGroup className={s.space3}>
                <div className={cx(s.siteContainer)}>
                  <label className={cs.labelTextNew} ><FormattedMessage {...messages.imageLabel} /> 1</label>
                  <Image image={whyBlockImage1} fieldName={"whyBlockImage1"} loader={whyBlock1loader} />
                </div>
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.whyBlockTitleLabel} /> 1</label>
                <MultiLanguageInput
                  baseField="whyBlockTitle1"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.whyBlockContentLabel} /> 1</label>
                <MultiLanguageInput
                  baseField="whyBlockContent1"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <div className={cx(s.siteContainer)}>
                  <label className={cs.labelTextNew}><FormattedMessage {...messages.imageLabel} /> 2</label>
                  <Image image={whyBlockImage2} fieldName={"whyBlockImage2"} loader={whyBlock2loader} />
                </div>
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.whyBlockTitleLabel2} /></label>
                <MultiLanguageInput
                  baseField="whyBlockTitle2"
                  inputType="text"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.space3}>
                <label className={cs.labelTextNew}><FormattedMessage {...messages.whyBlockContentLabel2} /></label>
                <MultiLanguageInput
                  baseField="whyBlockContent2"
                  inputType="textarea"
                  values={formValues}
                  onChange={this.handleFieldChange}
                />
              </FormGroup>
              <FormGroup className={s.noMargin}>
                <Row>
                  <Col xs={12} sm={12} md={12} lg={12} className={cx(cs.textAlignRight, 'textAlignLeftRTL')}>
                    <Button className={cx(cs.btnPrimary, cs.btnlarge)} type="submit" disabled={submitting}>
                      <FormattedMessage {...messages.save} />
                    </Button>
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

WhyHostFormBlock3 = reduxForm({
  form: 'WhyHostForm',
  validate,
  enableReinitialize: true,
  keepDirtyOnReinitialize: false
})(WhyHostFormBlock3);

const selector = formValueSelector('WhyHostForm');

const textFields = ['whyBlockTitle1', 'whyBlockContent1', 'whyBlockTitle2', 'whyBlockContent2'];
const languages = ['', '_en', '_fr', '_it', '_pt'];

const mapState = (state) => {
  const formValues = {};
  textFields.forEach(field => {
    languages.forEach(lang => {
      formValues[`${field}${lang}`] = selector(state, `${field}${lang}`);
    });
  });
  
  return {
    formValues,
    whyBlock1loader: state?.loader?.whyBlockImage1,
    whyBlock2Loader: state?.loader?.whyBlockImage2,
    whyBlockImage1: selector(state, 'whyBlockImage1'),
    whyBlockImage2: selector(state, 'whyBlockImage2'),
  };
};

const mapDispatch = {};

export default compose(
  withStyles(s, cs),
  injectIntl,
  connect(mapState, mapDispatch)
)(WhyHostFormBlock3);